module.exports = __webpack_public_path__ + "static/media/20210212_213734_758_IMG_2161.ecc5e59d.jpg";